import React, { useEffect, useState } from 'react';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-sage/15 bg-white/95 backdrop-blur-sm transition-[transform,opacity] duration-200 ease-out lg:hidden ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-247" data-mp="3pdsjn4nl8xrs">
      <div className="mx-auto flex max-w-content items-center justify-between gap-3 px-4 py-3" data-id="element-248" data-mp="3kmsoo4y14prx">
        <p className="font-sans text-sm font-semibold leading-tight text-ink" data-id="element-249" data-mp="c70kvkopke4u">
          Screen &amp; Adapt™
        </p>
        <a href="#pricing" className="shrink-0 rounded-xl bg-sage px-5 py-3 font-sans text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-sage-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2" data-id="element-250" data-mp="gy8vgk1ry5jl">
          Get instant access
        </a>
      </div>
    </div>;
}